module.exports = wp.htmlEntities;